// extracted by mini-css-extract-plugin
module.exports = {"restaurants":"Restaurants_restaurants__2U-g5","restaurantsItems":"Restaurants_restaurantsItems__1nQdI"};